<template>
  <div class="quotation">
    <el-row>
      <el-col
        :xs="{ span: 24, offset: 0 }"
        :sm="{ span: 24, offset: 0 }"
        :md="{ span: 22, offset: 1 }"
        :lg="{ span: 22, offset: 1 }"
        :xl="{ span: 20, offset: 2 }"
      >
        <div class="from-wrapper">
          <el-row class="header"> Get Your Quotation </el-row>
          <el-divider />
          <el-form
            ref="quotation"
            :model="quotation"
            :rules="rules"
            label-width="auto"
            :label-position="labelPosition"
            label-suffix="："
            class="from"
            size="mini"
          >
            <el-form-item label="Your Name" prop="name">
              <el-col :md="inputSpan * 2">
                <el-input
                  v-model="quotation.name"
                  :maxlength="maxInputLength"
                  show-word-limit
                ></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="Product Name" prop="productName">
              <el-col :md="inputSpan * 2">
                <el-input
                  v-model="quotation.productName"
                  :maxlength="maxInputLength"
                  show-word-limit
                ></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="Product category" prop="mouldType">
              <el-col :md="inputSpan">
                <el-cascader
                  ref="categorycascader"
                  v-model="quotation.productCategoryId"
                  style="width: 100%"
                  :options="categoryOptions"
                  :show-all-levels="false"
                  :props="propsOption"
                  @change="categoryCascaderChange"
                ></el-cascader>
              </el-col>
            </el-form-item>
            <el-form-item label="Requirements" prop="requirements">
              <el-col :md="inputSpan * 2">
                <el-input
                  v-model="quotation.requirements"
                  type="textarea"
                  maxlength="8000"
                  show-word-limit
                />
              </el-col>
            </el-form-item>
            <el-form-item label="Material" prop="material">
              <el-col :md="inputSpan">
                <el-input
                  v-model="quotation.material"
                  :maxlength="maxInputLength"
                  show-word-limit
                />
              </el-col>
            </el-form-item>
            <el-form-item label="Size/Dimension" prop="sizeDimension">
              <el-col :md="inputSpan">
                <el-input
                  v-model="quotation.sizeDimension"
                  :maxlength="maxInputLength"
                  show-word-limit
                />
              </el-col>
            </el-form-item>
            <el-form-item
              label="Grade/Quality standard"
              prop="gradeQualityStandard"
            >
              <el-col :md="inputSpan">
                <el-input
                  v-model="quotation.gradeQualityStandard"
                  :maxlength="maxInputLength"
                  show-word-limit
                />
              </el-col>
            </el-form-item>
            <el-form-item
              label="Packaging requirements"
              prop="packagingRequirements"
            >
              <el-col :md="inputSpan">
                <el-input
                  v-model="quotation.packagingRequirements"
                  :maxlength="maxInputLength"
                  show-word-limit
                />
              </el-col>
            </el-form-item>
            <el-form-item label="Shipment terms" prop="shipmentTerms">
              <el-col :md="inputSpan">
                <el-input
                  v-model="quotation.shipmentTerms"
                  :maxlength="maxInputLength"
                  show-word-limit
                />
              </el-col>
            </el-form-item>
            <el-form-item label="Destination port" prop="destinationPort">
              <el-col :md="inputSpan">
                <el-input
                  v-model="quotation.destinationPort"
                  :maxlength="maxInputLength"
                  show-word-limit
                />
              </el-col>
            </el-form-item>
            <div style="display: flex">
              <div
                v-if="showTip"
                style="position: relative; z-index: 9"
                @mouseover="showToolTip = true"
                @mouseleave="showToolTip = false"
              >
                <i
                  class="el-icon-question"
                  style="
                    color: red;
                    width: 10px;
                    padding-top: 5px;
                    font-size: 1.2rem;
                  "
                ></i>
              </div>

              <el-form-item
                label="Upload attachments"
                prop="uploadAttachmentsId"
                style="margin-left: -10px"
              >
                <div v-if="showToolTip" class="tool-tip-wrapper">
                  <div class="tool-tip">Upload product image/attachments</div>
                  <div class="triangle"></div>
                </div>
                <div class="upload-btn">
                  <el-upload
                    ref="upload"
                    :action="uploadUrl"
                    :file-list="fileList"
                    style="text-align: left"
                    :on-remove="handleRemove"
                    :on-error="handleUploadFailed"
                    :on-success="handleUploadSuccess"
                    :before-upload="handleBeforeUpload"
                  >
                    <el-button size="small" type="primary"
                      >Select file</el-button
                    >
                  </el-upload>
                </div>
              </el-form-item>
            </div>

            <el-form-item
              label="Estimated order quantity"
              prop="estimatedOrderQuantity"
            >
              <el-col :md="inputSpan">
                <el-input
                  v-model="quotation.estimatedOrderQuantity"
                  :maxlength="maxInputLength"
                  show-word-limit
                  style="width: 100%"
                ></el-input>
              </el-col>
            </el-form-item>

            <el-form-item
              label=" Preferred unit price"
              prop="preferredUnitPrice"
            >
              <el-col :md="inputSpan">
                <el-input
                  v-model="quotation.preferredUnitPrice"
                  :maxlength="maxInputLength"
                  style="width: 100%"
                >
                  <el-select
                    slot="prepend"
                    v-model="quotation.unit"
                    placeholder=""
                    style="width: 80px"
                  >
                    <el-option label="USD" value="USD"></el-option>
                    <el-option label="CNY" value="CNY"></el-option>
                    <el-option label="EUR" value="EUR"></el-option>
                  </el-select>
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="Valid to" prop="validTo">
              <el-col :md="inputSpan">
                <el-date-picker
                  ref="validTo"
                  v-model="quotation.validTo"
                  style="width: 100%"
                  :editable="showTip"
                  @focus="scrollDatePicker"
                />
              </el-col>
            </el-form-item>

            <el-form-item
              label="Business phone number"
              prop="businessPhoneNumber"
            >
              <el-col :md="inputSpan">
                <el-input v-model="quotation.businessPhoneNumber" />
                <!--                <vue-tel-input v-model="quotation.rawPhoneNumber" placeholder="" style="height: 28px" @country-changed="handleCountryChange" @validate="handleValidatePhoneNo" @blur="validatePhoneNo"></vue-tel-input>-->
              </el-col>
            </el-form-item>

            <el-form-item label=" E-mail" prop="email">
              <el-col :md="inputSpan">
                <el-input
                  v-model="quotation.email"
                  :maxlength="maxInputLength"
                />
              </el-col>
            </el-form-item>
            <div class="submit-btn">
              <el-button size="small " @click="goToHomePage()"
                >Cancel</el-button
              >
              <el-button
                size="small "
                type="primary"
                :loading="loading"
                @click="submitForm('quotation')"
                >Submit</el-button
              >
            </div>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import "./_Quotation.scss";
import mouldTypes from "../../static/mouldTypes";
import categoryOfMould from "../../static/categoryOfMould";
import { customFetch } from "../../utils/api";
import { palFormUrl, hmzyUrl } from "../../config/appConfig";
import { retryTips } from "../../static/staticText";
// import { VueTelInput } from 'vue-tel-input'

const fileUploadUrl = `${palFormUrl}/fileHandler/uploadFile`;
const imageUploadUrl = `${hmzyUrl}/fileHandler/uploadImage`;

// let isValidPhoneNo = false;
// const phoneNoValidator = (rule, value, callback) => {
//     if(!value){
//       callback(new Error('Phone No. is required'));
//     }
//
//     if(!isValidPhoneNo){
//       callback(new Error('Invalid phone number'));
//     }
//   }

export default {
  name: "Quotation",
  // components: {
  //   VueTelInput,
  // },
  data() {
    return {
      isPhoneValid: false,
      mouldTypes,
      uploadUrl: fileUploadUrl,
      categoryOfMould,
      showToolTip: false,
      inputSpan: 8,
      loading: false,
      fileList: [],
      fileType: "",
      error: "",
      maxInputLength: 128,
      quotation: {
        name: "",
        productName: (this.$route.query && this.$route.query.name) || "",
        mouldType:
          (this.$route.query && mouldTypes[this.$route.query.mould]) || "",
        mouldCategory: [],
        requirements: "",
        material: "",
        sizeDimension: "",
        gradeQualityStandard: "",
        packagingRequirements: "",
        shipmentTerms: "",
        destinationPort: "",
        uploadAttachmentsId: "",
        estimatedOrderQuantity:
          (this.$route.query && this.$route.query.price) || "",
        validTo: "",
        businessPhoneNumber: "",
        // rawPhoneNumber: "",
        email: "",
        preferredUnitPrice: "",
        unit: "USD",
        countryCode: "",
        productCategoryId: "",
        productCategory: "",
      },
      categoryOptions: [],
      propsOption: {
        value: "id",
        label: "name",
        children: "internationalProductsCategoryList",
      },
      rules: {
        name: [
          { required: true, message: "", trigger: "blur" },
          { max: 128, message: "", trigger: "blur" },
        ],
        productName: [
          { required: true, message: "", trigger: "blur" },
          { max: 128, message: "", trigger: "blur" },
        ],
        mouldType: [
          {
            required: true,
            message: "Product category is required",
            trigger: "change",
          },
        ],
        requirements: [{ required: true, message: "", trigger: "blur" }],
        material: [{ max: 128, message: "", trigger: "blur" }],
        sizeDimension: [{ max: 128, message: "", trigger: "blur" }],
        gradeQualityStandard: [{ max: 128, message: "", trigger: "blur" }],
        packagingRequirements: [{ max: 128, message: "", trigger: "blur" }],
        shipmentTerms: [
          { required: true, message: "", trigger: "blur" },
          { max: 128, message: "", trigger: "blur" },
        ],
        destinationPort: [
          { required: true, message: "", trigger: "blur" },
          { max: 128, message: "", trigger: "blur" },
        ],
        estimatedOrderQuantity: [
          { required: true, message: "", trigger: "blur" },
          { max: 128, message: "", trigger: "blur" },
        ],
        validTo: [{ required: true, message: "", trigger: "blur" }],
        // rawPhoneNumber: [{ required: true, message: "", trigger: "blur" }],
        businessPhoneNumber: [
          { required: true, message: "", trigger: "blur" },
          { max: 128, message: "", trigger: "blur" },
        ],
        email: [
          { required: true, message: "", trigger: "blur" },
          {
            type: "email",
            message: "invalid E-mail",
            trigger: ["blur", "change"],
          },
        ],
        preferredUnitPrice: [
          { required: true, message: "", trigger: "blur" },
          { max: 128, message: "", trigger: "blur" },
        ],
        uploadAttachmentsId: [
          {
            required: true,
            message: "attachments is required",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    fullCategoryOfMould() {
      const res = [];
      if (categoryOfMould[this.quotation.mouldType]) {
        categoryOfMould[this.quotation.mouldType].forEach((item) => {
          if (typeof item === "string") {
            res.push({
              value: item,
              label: item,
            });
          } else {
            res.push(
              ...Object.keys(item).map((key) => {
                return {
                  value: key,
                  label: key,
                  children: item[key].map((subMenu) => {
                    return {
                      value: subMenu,
                      label: subMenu,
                    };
                  }),
                };
              })
            );
          }
        });
      }
      return res;
    },

    labelPosition() {
      return this.$store.state.isMobile ? "top" : "right";
    },
    showTip() {
      return !this.$store.state.isMobile;
    },
  },
  mounted() {
    this.getAllCategory();
  },
  methods: {
    categoryCascaderChange(item) {
      console.log("item", item);
      console.log(
        "this.$refs.categorycascader",
        this.$refs.categorycascader.getCheckedNodes()
      );
      let obj = this.$refs.categorycascader.getCheckedNodes();
      console.log("obj[0]", obj[0]);
      this.quotation.mouldType = obj[0].label;
      this.quotation.mouldCategory = [obj[0].label];
      this.quotation.productCategoryId = obj[0].value;
      this.quotation.productCategory = obj[0].label;
    },
    getAllCategory() {
      customFetch(
        `${palFormUrl}/international/getInternationalProductsCategoryList`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: 0,
          }),
        },
        (res) => {
          res.result.forEach((item, index) => {
            this.goLevelCate(item, index);
          });
          this.categoryOptions = res.result;
          console.log(this.categoryOptions);
        },
        () => {}
      );
    },
    goLevelCate(item, index) {
      if (item.internationalProductsCategoryList.length > 0) {
        item.internationalProductsCategoryList.forEach((sub, index) => {
          this.goLevelCate(sub, index);
        });
      } else {
        delete item.internationalProductsCategoryList;
      }
    },
    submitForm(formName) {
      console.log(this.quotation);
      const self = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          let params = {
            ...this.quotation,
            preferredUnitPrice: `${this.quotation.preferredUnitPrice} ${this.quotation.unit}`,
          };
          console.log("params", params);
          customFetch(
            `${palFormUrl}/hicPlatform/createHicQuotation`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(params),
            },
            () => {
              self.loading = false;
              self.error = "";
              self
                .$confirm(
                  "Your request has been committed successfully, would you like to stay here or go back?",
                  "SUCCESS",
                  {
                    confirmButtonText: "Leave",
                    cancelButtonText: "Stay",
                    type: "success",
                  }
                )
                .then(() => {
                  this.$router.push("/");
                })
                .catch(() => {
                  self.resetForm(formName);
                });
            },
            () => {
              self.loading = false;
              self
                .$confirm(retryTips, "FAILED", {
                  confirmButtonText: "Try Again",
                  cancelButtonText: "Cancel",
                  type: "error",
                })
                .then(() => {
                  self.submitForm(formName);
                })
                .catch(() => {});
            }
          );
        } else {
          return false;
        }
      });
    },
    handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.quotation.uploadAttachmentsId = "";
        this.quotation.uploadAttachmentsName = "";
        this.$refs["quotation"].validateField("uploadAttachmentsId");
      }
    },
    handleUploadFailed() {
      this.$notify.error({
        title: "Upload failed!",
        message: "Failed to upload the file",
        showClose: false,
      });
    },
    // handleChange(file, fileList) {
    //   this.fileList = fileList.slice(-1);
    // },
    handleUploadSuccess(response, file) {
      const { success, result } = response;
      if (success) {
        if (this.fileType === "file") {
          //上传文件
          const { fileId, fileName } = result;
          this.quotation.uploadAttachmentsId = fileId;
          this.quotation.uploadAttachmentsName = fileName;
        } else if (this.fileType === "image") {
          //上传图片
          const { url, fileName } = result;
          this.quotation.uploadAttachmentsId = url;
          this.quotation.uploadAttachmentsName = fileName;
        }
        this.$refs["quotation"].validateField("uploadAttachmentsId");
      }
    },
    handleBeforeUpload(file) {
      //限制上传文件大小
      if (file.size / 1024 / 1024 > 50) {
        this.$notify.error({
          title: "Cannot upload",
          message: "The file you selected should be less than 50MB",
          showClose: false,
        });
        return false;
      }

      return new Promise((resolve) => {
        this.$nextTick(() => {
          if (file.type.indexOf("image") === -1) {
            this.uploadUrl = fileUploadUrl;
            this.fileType = "file";
          } else {
            this.uploadUrl = imageUploadUrl;
            this.fileType = "image";
          }
          this.fileList = [file];
          resolve();
        });
      });
    },
    // validatePhoneNo() {
    //   this.$refs["quotation"].validateField("rawPhoneNumber");
    // },
    // handleValidatePhoneNo(valid){
    //   this.quotation.businessPhoneNumber = valid.number.international
    //   // if(valid.isValid){
    //   //   isValidPhoneNo = true;
    //   // }else {
    //   //   isValidPhoneNo = false;
    //   // }
    // },
    // handleCountryChange(country) {
    //   console.log(country)
    //   this.quotation.countryCode = `+${country.dialCode}`
    // },
    resetForm(formName) {
      this.fileList = [];
      this.$refs[formName].resetFields();
    },
    goToHomePage() {
      this.$router.push("/");
    },
    scrollDatePicker() {
      this.$refs["validTo"].scrollIntoView();
    },
  },
};
</script>
<style scoped lang="scss">
@import "./_Quotation.scss";
</style>
